import React, { Component, RefObject, ChangeEvent, KeyboardEvent } from 'react'

import TextInput from 'tfs.form-text-input'
import SSR from '../../interfaces/client/SSR'

export interface SsrAutoCompletePropsInterface {
  options: SSR[]
  name: string
  required?: boolean
  autocomplete?: string
  onConfirm: Function
  elementRef: RefObject<any>

  dataElement?: string
}

class SsrAutoComplete extends Component<SsrAutoCompletePropsInterface> {
  state = {
    value: '',
  }

  private _confirmInput(option: SSR) {
    if (
      typeof option.availableCount === 'number' &&
      option.availableCount > 0
    ) {
      this.setState({ value: option.id })
      this.props.onConfirm(option.id)
    }
  }

  private _findMatch(input = '') {
    const { options } = this.props
    let inputLowerCase = input.toLowerCase()
    const textInBrackets = inputLowerCase.match(/\([^)]*\)(?!.*\1)/g)

    // Remove 'availableCount' from input for comparison with available ssr's
    if (textInBrackets != null) {
      const indexOfAvailableCount = inputLowerCase.lastIndexOf(textInBrackets.reverse()[0])
      inputLowerCase = inputLowerCase.substring(0, indexOfAvailableCount)
    }

    return (
      input &&
      options.find(option => {
        const name = option.name.toLowerCase()
        const id = option.id.toLowerCase()

        return (
          name.includes(inputLowerCase) ||
          id.includes(inputLowerCase) ||
          inputLowerCase === `${name} [${id}]`
        )
      })
    )
  }

  private _onKeyPress(event: KeyboardEvent<HTMLInputElement>) {
    const { key } = event.nativeEvent

    if (key === 'Enter') {
      const { value } = event.currentTarget
      const match = this._findMatch(value)

      if (match) {
        this._confirmInput(match)
      }
      event.preventDefault()
    }
  }

  private _onChange(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target
    this.setState({ value })

    // This condition will pass when directly selecting an option from the datalist
    if (
      (event.nativeEvent as any).data === undefined ||
      (event.nativeEvent as any).inputType === 'insertReplacementText'
    ) {
      const match = this._findMatch(value)

      if (match) {
        this._confirmInput(match)
      }
    }
  }

  // This will bind the datalist to the input
  componentDidMount() {
    const { elementRef, name } = this.props
    if (elementRef.current) {
      elementRef.current.setAttribute('id', '')
      elementRef.current.setAttribute('list', name)
    }
  }

  render() {
    const { value } = this.state
    const {
      name,
      required,
      dataElement,
      autocomplete,
      options,
      elementRef,
    } = this.props

    return (
      <div>
        <TextInput
          name={name}
          required={required}
          type="text"
          elementRef={elementRef}
          value={value}
          onChange={this._onChange.bind(this)}
          autoComplete={autocomplete}
          onKeyPress={this._onKeyPress.bind(this)}
          data-element={dataElement || name}
        />

        <datalist id={name}>
          {options.map((option: SSR) => (
            <option key={option.id}>
              {/* Show the ID until the option names (labels) have been loaded */}
              {option.name !== option.id
                ? `${option.name} [${option.id}]`
                : option.id}
              {option.isLimited &&
              typeof option.availableCount === 'number' &&
              option.availableCount < 90
                ? `(${option.availableCount})`
                : ``}
            </option>
          ))}
        </datalist>
      </div>
    )
  }
}

export default SsrAutoComplete
